import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo-section" onClick={() => scrollToSection('hero')}>
          <img 
            src="https://customer-assets.emergentagent.com/job_edu-coach-9/artifacts/xkfexqp6_logo_black_on_white_sharp_simple.png" 
            alt="LookApp Logo" 
            className="logo-img"
          />
          <span className="logo-text">LookApp</span>
        </div>

        <nav className={`nav-menu ${isMobileMenuOpen ? 'open' : ''}`}>
          <a onClick={() => scrollToSection('services')} className="nav-link">Usluge</a>
          <a onClick={() => scrollToSection('about')} className="nav-link">O nama</a>
          <a onClick={() => scrollToSection('portfolio')} className="nav-link">Iskustvo</a>
          <a onClick={() => scrollToSection('testimonials')} className="nav-link">Preporuke</a>
          <a onClick={() => scrollToSection('contact')} className="nav-link nav-link-cta">Kontakt</a>
        </nav>

        <button 
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
};

export default Header;
